import { z } from 'zod';

import { TARGET_MARKET } from '@/lib/data/domains/role';
import { USER_TYPE } from '@/lib/data/domains/user';

const PermissionScopeSchema = z.object({
  id: z.string().optional(),
  isChecked: z.boolean(),
});

export const PermissionItemSchema: z.ZodType<any> = z.lazy(() =>
  z.object({
    id: z.string(),
    label: z.string(),
    resourcePath: z.string().optional(),
    resourceScope: z.object({
      create: PermissionScopeSchema.optional(),
      read: PermissionScopeSchema.optional(),
      update: PermissionScopeSchema.optional(),
      delete: PermissionScopeSchema.optional(),
    }),
    children: z.array(PermissionItemSchema).optional(),
    // Form-only; mapped to/from `hiddenResources` on load and save
    isVisible: z.boolean().optional(),
  }),
);

export const RolePermissionFormSchema = z.object({
  id: z.string(),
  concurrencyToken: z.string().optional(),
  name: z.string(),
  description: z.string(),
  userType: z.nativeEnum(USER_TYPE),
  targetMarket: z.nativeEnum(TARGET_MARKET),
  permissions: z.object({
    web: z.array(PermissionItemSchema),
    dashboard: z.array(PermissionItemSchema),
    app: z.array(PermissionItemSchema),
  }),
});

export const RoleRenameFormSchema = z
  .object({
    description: z.string(),
  })
  .superRefine((data, ctx) => {
    if (!data.description?.trim()) {
      ctx.addIssue({
        path: ['description'],
        message: 'Permission role name is required',
        code: 'custom',
      });
    }
  });

export const RoleFormSchema = z
  .object({
    id: z.string(),
    roleType: z.string(),
    description: z.string(),
    userType: z.nativeEnum(USER_TYPE),
    targetMarket: z.object({
      id: z.string(),
      name: z.string(),
    }),
    permissions: z.object({
      web: z.array(PermissionItemSchema),
      dashboard: z.array(PermissionItemSchema),
      app: z.array(PermissionItemSchema),
    }),
  })
  .superRefine((data, ctx: any) => {
    if (!data.description?.trim()) {
      ctx.addIssue({
        path: ['description'],
        message: 'Permission role name is required',
        code: 'custom',
      });
    }

    if (!data.targetMarket.id) {
      ctx.addIssue({
        path: ['targetMarket'],
        message: 'Target market is required',
        code: 'custom',
      });
    }
  });
